import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAdmin } from "../../context/AdminContext";

const PrivateAdminRoute = ({ children }) => {
  const { isAdmin } = useAdmin();
  const location = useLocation();

  if (!isAdmin) {
    return <Navigate to="*" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateAdminRoute;
